import { render } from "./Sucursal.vue?vue&type=template&id=22ac0542"
import script from "./Sucursal.vue?vue&type=script&lang=js"
export * from "./Sucursal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\vue\\italos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__